/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';



const  generateSummary =  (data) => {
  var url = '';
  if(data.clips_ID === undefined){
    url = maverickPortalApiEndPoint.generateSummary.url+`?project_id=${data.project_ID}`
  }
  else{
    url = maverickPortalApiEndPoint.generateSummary.url+`?clip_id=${data.clips_ID}&project_id=${data.project_ID}`
  }
  
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequestWithoutBase(
        url,
        maverickPortalApiEndPoint.generateSummary.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};
const  storeAISummaryLogs =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.storeAISummaryLogs.url,
        maverickPortalApiEndPoint.storeAISummaryLogs.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};



export { generateSummary,storeAISummaryLogs};
